<proffeo-ui-page-wrapper>
  <div
    pageActions
    class="flex w-full justify-between"
  >
    <button
      (click)="openCreateOshAnalysisDialog()"
      class="button-accent fixed bottom-10 right-10 flex h-10 w-10 cursor-pointer gap-1 p-0"
    >
      <mat-icon
        fontIcon="add"
        class="h-[24px]! w-[24px]! text-[24px]!"
      />
    </button>
  </div>
  <div
    [proffeoSpinner]="getCompanyOshAnalyses() === undefined"
    proffeoSpinnerSize="lg"
    class="min-h-48 w-full pt-3 lg:pt-6"
  >
    @if (getCompanyOshAnalyses()?.length === 0) {
      <div class="flex w-full items-center justify-center p-4">
        <p>{{ 'placeholders.no-results-found' | translate }}</p>
      </div>
    } @else if (getCompanyOshAnalyses(); as analyses) {
      <proffeo-osh-tree
        (oshAnalysisEdited)="editOshAnalysis($event)"
        (oshAnalysisDeleted)="deleteOshAnalysis($event)"
        [oshAnalyses]="analyses"
      ></proffeo-osh-tree>
    }
  </div>
</proffeo-ui-page-wrapper>
